import { FileText, Check, ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { SITE } from "../config/site";
import { trackEvent } from "../lib/analytics";

const INSIDE = [
  "The full customer journey: how Indian pilgrims and families actually discover, evaluate and choose a travel agency",
  "Where most agencies lose enquiries, and how to plug the leaks",
  "The WhatsApp-first follow-up structure that turns interest into real conversations",
  "How Meta Ads and Google Ads fit together around Hajj and Umrah seasons",
  "Budget planning pointers: what to expect before you spend a rupee",
];

export const BlueprintSection = () => (
  <section
    className="bg-charcoal py-24 md:py-32 relative overflow-hidden"
    data-testid="blueprint-section"
  >
    <div className="absolute inset-0 geo-pattern-light opacity-[0.05]" />
    <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal>
        <SectionTag dark className="mb-6">
          Free Resource
        </SectionTag>
        <h2 className="text-3xl md:text-5xl font-bold tracking-tighter text-cream leading-[1.05]">
          The Free Customer Growth{" "}
          <span className="text-gold">Blueprint.</span>
        </h2>
        <p className="mt-6 text-base text-cream/60 leading-relaxed max-w-xl">
          A practical, no-fluff guide for Indian Hajj &amp; Umrah travel
          agencies: how a modern customer acquisition system actually works,
          from the first ad impression to a booked consultation.
        </p>
        <ul className="mt-9 space-y-4">
          {INSIDE.map((item, i) => (
            <li
              key={i}
              className="flex items-start gap-3"
              data-testid={`blueprint-benefit-${i + 1}`}
            >
              <Check
                size={16}
                strokeWidth={2}
                className="mt-1 shrink-0 text-gold"
              />
              <span className="text-sm text-cream/75 leading-relaxed">
                {item}
              </span>
            </li>
          ))}
        </ul>
        <div className="mt-10 flex flex-wrap items-center gap-5">
          <a
            href={SITE.blueprintUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="blueprint-section-cta"
            onClick={() =>
              trackEvent("cta_click", {
                cta: "growth_blueprint",
                placement: "blueprint_section",
              })
            }
            className="group inline-flex items-center gap-2 bg-tan text-cream text-sm font-semibold tracking-wide px-8 py-4 transition-colors duration-300 hover:bg-gold hover:text-charcoal"
          >
            Download the Free Blueprint
            <ArrowUpRight
              size={16}
              strokeWidth={1.5}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </a>
          <span className="text-xs text-cream/40">
            Free PDF. Opens in a new tab.
          </span>
        </div>
      </Reveal>

      <Reveal delay={0.15} className="relative">
        <div className="relative max-w-sm mx-auto lg:ml-auto">
          <div className="absolute -top-5 -left-5 w-full h-full border border-gold/40" />
          <div
            className="relative bg-cream p-8 md:p-10 shadow-[0_24px_60px_rgba(0,0,0,0.35)]"
            data-testid="blueprint-preview-card"
          >
            <div className="flex items-center justify-between">
              <span className="h-2.5 w-2.5 rotate-45 bg-gold" />
              <FileText size={18} strokeWidth={1.5} className="text-tan" />
            </div>
            <div className="mt-8 text-[10px] font-semibold tracking-[0.3em] uppercase text-tan">
              Nexus Catalyst Agency
            </div>
            <div className="mt-3 text-2xl md:text-3xl font-bold tracking-tight text-charcoal leading-tight">
              Customer Growth Blueprint
            </div>
            <div className="mt-3 text-xs text-charcoal/55 leading-relaxed">
              For Hajj &amp; Umrah travel agencies in India
            </div>
            <div className="mt-8 space-y-3">
              {[92, 78, 85, 60].map((w, i) => (
                <div
                  key={i}
                  className="h-1.5 bg-charcoal/10"
                  style={{ width: `${w}%` }}
                />
              ))}
            </div>
            <div className="mt-8 pt-5 border-t border-charcoal/10 flex items-center justify-between">
              <span className="text-[10px] font-semibold tracking-[0.25em] uppercase text-charcoal/40">
                Free Download
              </span>
              <span className="h-2 w-2 rotate-45 bg-tan" />
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
